import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { first, tap } from 'rxjs';

import { Attachment, AttachmentsService, FormQualitySubmissionDto } from '@assess/browser/api';
import { IAttachment } from '@assess/shared/entities';

export interface IQualitySubmissionsData {
  formQualitySubmissions: FormQualitySubmissionDto[];
}

export const displayedColumns = [
  'sectionLabel',
  'evidenceDate',
  'procedureName',
  'dateOfService',
  'attachments',
  'submittedInfo',
];

@Component({
  selector: 'assess-quality-submissions-dialog',
  templateUrl: './quality-submissions-dialog.component.html',
  styleUrls: ['./quality-submissions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QualitySubmissionsDialogComponent implements OnInit {
  displayedColumns: string[] = displayedColumns;
  dataSource: FormQualitySubmissionDto[] = [];

  readonly dateFormat = 'yyyy-MM-dd';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IQualitySubmissionsData,
    private readonly attachmentsService: AttachmentsService
  ) {}

  ngOnInit() {
    this.dataSource = this.data.formQualitySubmissions;
  }

  onAttachmentDownload(attachment: Attachment | IAttachment) {
    this.attachmentsService
      .getAttachmentUrl({
        attachmentId: attachment.id,
        entityClass: attachment.entityClass,
        entityId: attachment.entityId,
      })
      .pipe(
        first(),
        tap((downloadUrl) => window.open(downloadUrl.expiringUrl, '_blank'))
      )
      .subscribe();
  }
}
